import { useEffect, useRef } from 'react'
import { useAuth } from 'react-oidc-context'
import { useNavigate } from 'react-router-dom'
import { consumePostLoginRedirectPath } from '../../features/Auth/utils.ts'

export const AuthCallback = () => {
  const navigate = useNavigate()
  const { isLoading } = useAuth()
  const hasHandledRedirect = useRef(false)

  useEffect(() => {
    if (isLoading || hasHandledRedirect.current) {
      return
    }

    hasHandledRedirect.current = true
    const redirectUrl = consumePostLoginRedirectPath() ?? '/'
    navigate(redirectUrl, { replace: true })
  }, [isLoading, navigate])

  return null
}
